
function fetchRecommendations(id, apiClient) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}/bibs/${id}/recommendations/`;
  return apiClient.get(route);
}

export default {
  fetchRecommendations
};



// WEBPACK FOOTER //
// ./app/api/RecommendationApi.js